import { render, staticRenderFns } from "./icon-info.vue?vue&type=template&id=744526c6&scoped=true&"
import script from "./icon-info.vue?vue&type=script&lang=js&"
export * from "./icon-info.vue?vue&type=script&lang=js&"
import style0 from "./icon-info.vue?vue&type=style&index=0&id=744526c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744526c6",
  null
  
)

export default component.exports